const FILTER_TYPES = {
  DATE: 'date',
  RADIO_BUTTON: 'radio-button',
  CHECKBOX: 'checkbox',
  DATE_IN_RANGE: 'date-in-range'
};

export default FILTER_TYPES;
